export default {
  1: {
    name: 'Montevideo',
    latitud: '-34.90457590766654',
    longitud: '-56.18647783654048',
  },
  2: {
    name: 'Shangrila',
    latitud: '-34.8466371468928',
    longitud: '-55.9998248791853',
  },
  3: {
    name: 'Parque Miramar',
    latitud: '-34.8658913173045',
    longitud: '-56.0384598423224',
  },
  4: {
    name: 'Paso Carrasco',
    latitud: '-34.8572078959411',
    longitud: '-56.0444139731836',
  },
  5: {
    name: 'Barra de Carrasco',
    latitud: '-34.870437163594',
    longitud: '-56.026715741801',
  },
  7: {
    name: 'San Jose de Carrasco',
    latitud: '-34.8416625205649',
    longitud: '-55.9939384576022',
  },
  8: {
    name: 'Lagomar',
    latitud: '-34.8327207917337',
    longitud: '-55.9875773248557',
  },
  9: {
    name: 'El Bosque',
    latitud: '-34.8373287362849',
    longitud: '-55.9729365900827',
  },
  10: {
    name: 'Solymar',
    latitud: '-34.826984046246',
    longitud: '-55.9670562608742',
  },
  11: {
    name: 'Parque de Solymar',
    latitud: '-34.8243999017275',
    longitud: '-55.9473476860408',
  },
  13: {
    name: 'Lomas de Solymar',
    latitud: '-34.8175590381506',
    longitud: '-55.9365436975171',
  },
  14: {
    name: 'El Pinar',
    latitud: '-34.7950703098264',
    longitud: '-55.8982381638464',
  },
  15: {
    name: 'Neptunia',
    latitud: '-34.7824246200474',
    longitud: '-55.8790810967145',
  },
  16: {
    name: 'Pinamar',
    latitud: '-34.7782141889123',
    longitud: '-55.8558169979784',
  },
  17: {
    name: 'Trinidad',
    latitud: '-33.5187382435684',
    longitud: '-56.8995348126224',
  },
  18: {
    name: 'Salinas',
    latitud: '-34.7735175693607',
    longitud: '-55.8413615982659',
  },
  19: {
    name: 'Marindia',
    latitud: '-34.7729909444308',
    longitud: '-55.8236049277567',
  },
  20: {
    name: 'Fortin de Santa Rosa',
    latitud: '-34.7720752808162',
    longitud: '-55.8025464686794',
  },
  21: {
    name: 'Villa Argentina',
    latitud: '-34.7686614997694',
    longitud: '-55.7732051275681',
  },
  22: {
    name: 'Atlantida',
    latitud: '-34.7685143896485',
    longitud: '-55.7611719460807',
  },
  23: {
    name: 'Las Toscas',
    latitud: '-34.7649515268777',
    longitud: '-55.7400319065896',
  },
  24: {
    name: 'Parque del Plata',
    latitud: '-34.757956166471',
    longitud: '-55.7134714891823',
  },
  25: {
    name: 'La Floresta',
    latitud: '-34.7544247999733',
    longitud: '-55.6823392293415',
  },
  26: {
    name: 'Costa Azul',
    latitud: '-34.7614491100616',
    longitud: '-55.6615258391866',
  },
  27: {
    name: 'Canelones',
    latitud: '-34.5227539874196',
    longitud: '-56.2824365189061',
  },
  28: {
    name: 'Las Piedras',
    latitud: '-34.7161352645701',
    longitud: '-56.2108391145507',
  },
  29: {
    name: 'Pando',
    latitud: '-34.7179151189096',
    longitud: '-55.9498656172736',
  },
  30: {
    name: 'Santa Lucia',
    latitud: '-34.4504562832517',
    longitud: '-56.3887162346961',
  },
  31: {
    name: 'La Paz',
    latitud: '-34.7542076540923',
    longitud: '-56.2376964309397',
  },
  32: {
    name: 'San José',
    latitud: '-34.3386622099007',
    longitud: '-56.709675836126',
  },
  33: {
    name: 'Playa Pascual',
    latitud: '-34.7468044206443',
    longitud: '-56.450479532402',
  },
  34: {
    name: 'Rocha',
    latitud: '-34.4802243978893',
    longitud: '-54.3319439416719',
  },
  35: {
    name: 'Castillos',
    latitud: '-34.2002442761358',
    longitud: '-53.8583541422535',
  },
  39: {
    name: 'Tacuarembó',
    latitud: '-31.718689127084',
    longitud: '-55.9910458664695',
  },
  41: {
    name: 'San Ramon',
    latitud: '-34.2898576617723',
    longitud: '-55.9520559829504',
  },
  42: {
    name: 'Florida',
    latitud: '-34.0999672840721',
    longitud: '-56.2128090678348',
  },
  43: {
    name: 'Durazno',
    latitud: '-33.3843299908466',
    longitud: '-56.528912341703',
  },
  44: {
    name: 'Villa del Carmen',
    latitud: '-33.2364179159148',
    longitud: '-56.0077086785302',
  },
  45: {
    name: 'Maldonado',
    latitud: '-34.8970089999196',
    longitud: '-54.9519058090716',
  },
  46: {
    name: 'Punta del Este',
    latitud: '-34.9390111541926',
    longitud: '-54.9384531696936',
  },
  47: {
    name: 'San Carlos',
    latitud: '-34.789599974292',
    longitud: '-54.918413205126',
  },
  48: {
    name: 'Minas',
    latitud: '-34.3771278204167',
    longitud: '-55.2514385971649',
  },
  49: {
    name: 'Rincon del Pino',
    latitud: '-34.5028228020481',
    longitud: '-56.8346259764666',
  },
  50: {
    name: 'Piriapolis',
    latitud: '-34.8590920547379',
    longitud: '-55.2775065475024',
  },
  51: {
    name: 'Delta del Tigre',
    latitud: '-34.7616751947699',
    longitud: '-56.3606195361604',
  },
  52: {
    name: 'Paysandú',
    latitud: '-32.3109346151635',
    longitud: '-58.0881184228063',
  },
  53: {
    name: 'Mercedes',
    latitud: '-33.2586377184574',
    longitud: '-58.0077981289588',
  },
  54: {
    name: 'Cardona',
    latitud: '-33.8708352066841',
    longitud: '-57.3682128790948',
  },
  55: {
    name: 'Colonia del Sacramento',
    latitud: '-34.4537061072492',
    longitud: '-57.8365123804887',
  },
  56: {
    name: 'Nueva Palmira',
    latitud: '-33.8869537326677',
    longitud: '-58.4099852383817',
  },
  57: {
    name: 'Santa Rosa',
    latitud: '-34.4891535894837',
    longitud: '-56.0429926214075',
  },
  58: {
    name: 'Juan Lacaze',
    latitud: '-34.4285287170681',
    longitud: '-57.4427506473168',
  },
  59: {
    name: 'Carmelo',
    latitud: '-33.9995209890338',
    longitud: '-58.2890591961699',
  },
  60: {
    name: 'Libertad',
    latitud: '-34.6381563088168',
    longitud: '-56.6262931481872',
  },
  61: {
    name: 'Lascano',
    latitud: '-33.6757651184217',
    longitud: '-54.2113941150633',
  },
  62: {
    name: 'Salto',
    latitud: '-31.4095139733145',
    longitud: '-57.9405202246282',
  },
  63: {
    name: 'Balneario Santa Ana',
    latitud: '-34.4148975829184',
    longitud: '-57.6025096306294',
  },
  64: {
    name: 'Dolores',
    latitud: '-33.5509855135942',
    longitud: '-58.2029578353839',
  },
  65: {
    name: 'La Paloma',
    latitud: '-34.6543490953963',
    longitud: '-54.1688728818645',
  },
  66: {
    name: 'Treinta y Tres',
    latitud: '-33.2260922439061',
    longitud: '-54.3758434331449',
  },
  67: {
    name: 'Suarez',
    latitud: '-34.7362598977872',
    longitud: '-56.0390544169356',
  },
  68: {
    name: 'Chamizo',
    latitud: '-34.2459923179805',
    longitud: '-55.9216338892691',
  },
  69: {
    name: 'Toledo',
    latitud: '-34.7398216718936',
    longitud: '-56.0881700330733',
  },
  70: {
    name: 'Rosario',
    latitud: '-34.3171068436336',
    longitud: '-57.3461828516987',
  },
  71: {
    name: 'Progreso',
    latitud: '-34.6835832790945',
    longitud: '-56.2286669228487',
  },
  72: {
    name: 'San Bautista',
    latitud: '-34.4425351638365',
    longitud: '-55.9616375261444',
  },
  73: {
    name: 'San Jacinto',
    latitud: '-34.5467220954537',
    longitud: '-55.8722772256787',
  },
  74: {
    name: 'Fray Bentos',
    latitud: '-33.1233978037101',
    longitud: '-58.311583691897',
  },
  75: {
    name: 'Young',
    latitud: '-32.7000491384791',
    longitud: '-57.6435969748905',
  },
  76: {
    name: 'Melo',
    latitud: '-32.365713121392',
    longitud: '-54.1653157945436',
  },
  79: {
    name: 'Villa Rodriguez',
    latitud: '-34.3799990691582',
    longitud: '-56.5417184065565',
  },
  80: {
    name: 'Tala',
    latitud: '-34.3405678999871',
    longitud: '-55.7611394854249',
  },
  81: {
    name: 'Colonia Nicolich',
    latitud: '-34.8114280917591',
    longitud: '-56.0336005187614',
  },
  82: {
    name: 'Parque Carrasco',
    latitud: '-34.8521883264818',
    longitud: '-56.007865525807',
  },
  83: {
    name: 'Punta Ballena',
    latitud: '-34.8906120245297',
    longitud: '-55.0397624768264',
  },
  84: {
    name: 'Aigua',
    latitud: '-34.2068139457708',
    longitud: '-54.7681305938259',
  },
  85: {
    name: 'Tarariras',
    latitud: '-34.2749763156978',
    longitud: '-57.6114662637694',
  },
  86: {
    name: 'Sauce',
    latitud: '-34.6681305991989',
    longitud: '-56.0535366393645',
  },
  88: {
    name: 'Cerrillos',
    latitud: '-34.6090784330208',
    longitud: '-56.3597922436621',
  },
  89: {
    name: 'Barros Blancos',
    latitud: '-34.7661767977406',
    longitud: '-55.9939748897039',
  },
  90: {
    name: 'Sarandi Grande',
    latitud: '-33.7207030470266',
    longitud: '-56.3300918373352',
  },
  91: {
    name: 'Jose Batlle y Ordoñez',
    latitud: '-33.4679965921685',
    longitud: '-55.1438945669614',
  },
  92: {
    name: 'Villa San José',
    latitud: '-34.7233719625039',
    longitud: '-56.0671969093288',
  },
  94: {
    name: 'Paso de Los Toros',
    latitud: '-32.8072159645458',
    longitud: '-56.5187433707425',
  },
  95: {
    name: 'Montes',
    latitud: '-34.4933226440182',
    longitud: '-55.5527087219344',
  },
  97: {
    name: 'Guichon',
    latitud: '-32.3574429668399',
    longitud: '-57.1987565048169',
  },
  98: {
    name: 'Medanos de Solymar',
    latitud: '-34.8124843805241',
    longitud: '-55.9266020732917',
  },
  99: {
    name: 'Empalme Olmos',
    latitud: '-34.696545957842',
    longitud: '-55.9029608790217',
  },
  100: {
    name: 'Ecilda Paullier',
    latitud: '-34.3612970296592',
    longitud: '-57.0514863591777',
  },
  101: {
    name: 'Cerro Colorado',
    latitud: '-33.8602469288023',
    longitud: '-55.5399810737324',
  },
  102: {
    name: 'Sarandi del Yi',
    latitud: '-33.3421083476995',
    longitud: '-55.6333037320189',
  },
  103: {
    name: 'Pan de Azucar',
    latitud: '-34.7773307013239',
    longitud: '-55.2394061860761',
  },
  104: {
    name: 'Joanico',
    latitud: '-34.5974775853448',
    longitud: '-56.2540905945968',
  },
  105: {
    name: 'Jose Pedro Varela',
    latitud: '-33.4538694843346',
    longitud: '-54.5327470460512',
  },
  106: {
    name: 'Ombues de Lavalle',
    latitud: '-33.9397807212781',
    longitud: '-57.8084692304406',
  },
  107: {
    name: 'Las Brujas',
    latitud: '-34.6681952973631',
    longitud: '-56.3894313426704',
  },
  109: {
    name: 'Barra de Maldonado',
    latitud: '-34.9101876705397',
    longitud: '-54.8504238885838',
  },
  111: {
    name: '25 de Agosto',
    latitud: '-34.4155591740735',
    longitud: '-56.405957116346',
  },
  112: {
    name: 'Pueblo Agraciada',
    latitud: '-33.8111889555673',
    longitud: '-58.2735665319618',
  },
  113: {
    name: 'Solis',
    latitud: '-34.7918698773916',
    longitud: '-55.3836878024929',
  },
  116: {
    name: 'Rivera',
    latitud: '-30.8991299660608',
    longitud: '-55.533765678173',
  },
  117: {
    name: 'Cerro Chato(treinta...)',
    latitud: '-33.1071507504744',
    longitud: '-55.1301258655497',
  },
  118: {
    name: 'Algorta',
    latitud: '-32.4226576205811',
    longitud: '-57.3927957644161',
  },
  119: {
    name: 'Kiyu',
    latitud: '-34.6978787611764',
    longitud: '-56.7332730205935',
  },
  120: {
    name: 'Gregorio Aznares',
    latitud: '-34.7500495178864',
    longitud: '-55.400942964789',
  },
  121: {
    name: 'Rincon de La Bolsa',
    latitud: '-34.763491207727',
    longitud: '-56.3967595286382',
  },
  122: {
    name: 'Nueva Helvecia',
    latitud: '-34.293793187026',
    longitud: '-57.2282458895514',
  },
  123: {
    name: 'Puntas de Valdéz',
    latitud: '-34.5878111471481',
    longitud: '-56.701159341073',
  },
  124: {
    name: 'Egaña',
    latitud: '-33.6043317703297',
    longitud: '-57.6219663003769',
  },
  125: {
    name: 'Araminda',
    latitud: '-34.7822777825149',
    longitud: '-55.5568964898445',
  },
  126: {
    name: 'Cardal',
    latitud: '-34.2918508167456',
    longitud: '-56.3913781970598',
  },
  127: {
    name: 'Cuchilla Alta',
    latitud: '-34.7943935654053',
    longitud: '-55.4917792571435',
  },
  128: {
    name: 'Florencio Sanchez',
    latitud: '-33.8762558564241',
    longitud: '-57.3655091922179',
  },
  129: {
    name: 'San Gregorio (San José)',
    latitud: '-33.9403595907073',
    longitud: '-56.7517196386949',
  },
  132: {
    name: 'Mendoza Grande',
    latitud: '-34.2830735770064',
    longitud: '-56.2134557473631',
  },
  133: {
    name: 'Colonia Valdense',
    latitud: '-34.3395848546287',
    longitud: '-57.2586062884674',
  },
  134: {
    name: 'Agraciada',
    latitud: '-33.8075909482963',
    longitud: '-58.2670271091139',
  },
  136: {
    name: 'Mal Abrigo',
    latitud: '-34.1504404685866',
    longitud: '-56.9484368781236',
  },
  137: {
    name: 'Santa Lucia del Este',
    latitud: '-34.7929385986342',
    longitud: '-55.5329940085269',
  },
  138: {
    name: 'La Paloma',
    latitud: '-32.7245865619503',
    longitud: '-55.5855964065179',
  },
  139: {
    name: 'Artigas',
    latitud: '-30.4150174215412',
    longitud: '-56.466357365405',
  },
  140: {
    name: 'Bella Union',
    latitud: '-30.2573842323571',
    longitud: '-57.5897111517116',
  },
  141: {
    name: 'Migues',
    latitud: '-34.4832078911795',
    longitud: '-55.6265312770672',
  },
  143: {
    name: 'Las Flores',
    latitud: '-34.8099475081215',
    longitud: '-55.3246810938338',
  },
  144: {
    name: 'Tranqueras',
    latitud: '-31.1932393368563',
    longitud: '-55.761334807083',
  },
  145: {
    name: 'Fray Marcos',
    latitud: '-34.2097529935082',
    longitud: '-55.7391666106151',
  },
  149: {
    name: 'Solis de Mataojo',
    latitud: '-34.5993610347993',
    longitud: '-55.4661904901027',
  },
  150: {
    name: 'Tupambae',
    latitud: '-32.8362386610272',
    longitud: '-54.7630871747108',
  },
  152: {
    name: 'Blanquillo',
    latitud: '-32.8860036152612',
    longitud: '-55.6166566213692',
  },
  153: {
    name: 'Risso',
    latitud: '-33.6233179883012',
    longitud: '-57.5703125206612',
  },
  154: {
    name: 'Canelon Chico',
    latitud: '-34.7019453522751',
    longitud: '-56.178503716064',
  },
  156: {
    name: 'San Luis',
    latitud: '-34.773664180949',
    longitud: '-55.5886744247067',
  },
  157: {
    name: 'San Rafael - El Placer',
    latitud: '-34.9224147484853',
    longitud: '-54.8990918079984',
  },
  158: {
    name: 'Talita',
    latitud: '-33.9348151855823',
    longitud: '-56.1135352992168',
  },
  163: {
    name: 'Playa Verde',
    latitud: '-34.8156537648222',
    longitud: '-55.3168491382142',
  },
  166: {
    name: 'Colinas de Solymar',
    latitud: '-34.802722569741',
    longitud: '-55.9541987344791',
  },
  169: {
    name: 'Montes de Solymar',
    latitud: '-34.8116424622862',
    longitud: '-55.9552283914614',
  },
  170: {
    name: 'Jaureguiberry',
    latitud: '-34.7812040204669',
    longitud: '-55.4243062446257',
  },
  175: {
    name: 'Conchillas',
    latitud: '-34.149634',
    longitud: '-58.026172',
  },
  177: {
    name: 'Santa Bernardina',
    latitud: '-33.3608055150764',
    longitud: '-56.5122786602104',
  },
  178: {
    name: 'San Antonio',
    latitud: '-34.4466219952956',
    longitud: '-56.0776189712657',
  },
  179: {
    name: 'Palmitas',
    latitud: '-33.5050772592774',
    longitud: '-57.8015450333063',
  },
  180: {
    name: 'Castellanos',
    latitud: '-34.383967297549',
    longitud: '-55.9531452620525',
  },
  181: {
    name: 'Santa Teresita',
    latitud: '-34.8220668585545',
    longitud: '-56.0068507877172',
  },
  182: {
    name: 'Miguelete',
    latitud: '-34.0062274222128',
    longitud: '-57.6458244236597',
  },
  183: {
    name: 'Aeroparque',
    latitud: '-34.7819456864121',
    longitud: '-55.9878610943912',
  },
  184: {
    name: 'Playa Grande (Piriapolis)',
    latitud: '-34.8447737186183',
    longitud: '-55.2916531807674',
  },
  185: {
    name: 'Casupa',
    latitud: '-34.1030759714843',
    longitud: '-55.6434492613556',
  },
  186: {
    name: 'Santa Ana',
    latitud: '-34.7887503312218',
    longitud: '-55.4637695232858',
  },
  187: {
    name: 'Pinares Solymar',
    latitud: '-34.8060044555898',
    longitud: '-55.9428525331667',
  },
  190: {
    name: 'Mariscala',
    latitud: '-34.0465021948908',
    longitud: '-54.7764887658872',
  },
  191: {
    name: 'San Francisco(Piriapolis)',
    latitud: '-34.8844337794634',
    longitud: '-55.267445102563',
  },
  192: {
    name: 'Los Titanes',
    latitud: '-34.7811903491082',
    longitud: '-55.5667128582326',
  },
  194: {
    name: 'Soca',
    latitud: '-34.6770355773903',
    longitud: '-55.6979585140289',
  },
  195: {
    name: 'Punta Colorada',
    latitud: '-34.8976531024405',
    longitud: '-55.2453286632811',
  },
  198: {
    name: 'Rio Branco',
    latitud: '-32.5942546730662',
    longitud: '-53.3848046190159',
  },
  199: {
    name: 'Aguas Corrientes',
    latitud: '-34.5179301971297',
    longitud: '-56.395558498657',
  },
  201: {
    name: 'Carrasco del Sauce',
    latitud: '-34.6810527123237',
    longitud: '-56.1115220139267',
  },
  202: {
    name: 'Mendoza Chico',
    latitud: '-34.2453546827069',
    longitud: '-56.2160437991909',
  },
  203: {
    name: 'Villa Rives',
    latitud: '-34.776320821882',
    longitud: '-56.3754502709857',
  },
  204: {
    name: 'Vergara',
    latitud: '-32.9434362097684',
    longitud: '-53.9414904027044',
  },
  205: {
    name: 'La Coronilla',
    latitud: '-33.8931042587013',
    longitud: '-53.516173326441',
  },
  207: {
    name: 'Santa Clara de Olimar',
    latitud: '-32.9229160485621',
    longitud: '-54.9464210788806',
  },
  209: {
    name: 'Chuy',
    latitud: '-33.7016729383624',
    longitud: '-53.4435881991572',
  },
  210: {
    name: 'Rafael Perazza',
    latitud: '-34.5235817795906',
    longitud: '-56.7978494151559',
  },
  211: {
    name: '25 de Mayo',
    latitud: '-34.2053533999956',
    longitud: '-56.323158506685',
  },
  212: {
    name: 'La Tuna',
    latitud: '-34.7799182073776',
    longitud: '-55.5613667335855',
  },
  213: {
    name: 'San Gregorio de Polanco',
    latitud: '-32.6084510045642',
    longitud: '-55.8390721518284',
  },
  214: {
    name: 'Manantiales',
    latitud: '-34.901430285258',
    longitud: '-54.8291433607894',
  },
  215: {
    name: 'Playa Hermosa',
    latitud: '-34.8334216648218',
    longitud: '-55.3066641512667',
  },
  216: {
    name: 'Bello Horizonte',
    latitud: '-34.7679042992135',
    longitud: '-55.6479793620505',
  },
  218: {
    name: 'Guazuvira Nuevo',
    latitud: '-34.7639899312206',
    longitud: '-55.636216913668',
  },
  219: {
    name: 'Biarritz',
    latitud: '-34.7904777822406',
    longitud: '-55.5127374503394',
  },
  221: {
    name: 'La Paz',
    latitud: '-34.3553626809721',
    longitud: '-57.3148086771844',
  },
  224: {
    name: 'Jose Enrique Rodo',
    latitud: '-33.6963148672535',
    longitud: '-57.5282230047367',
  },
  227: {
    name: 'Minas de Corrales',
    latitud: '-31.5752687396323',
    longitud: '-55.4746193314233',
  },
  228: {
    name: 'Autodromo Nacional',
    latitud: '-34.762840259891',
    longitud: '-56.4110292930141',
  },
  229: {
    name: 'San Fernando',
    latitud: '-34.7702321107811',
    longitud: '-56.3879888996185',
  },
  230: {
    name: 'Velazquez',
    latitud: '-34.0327787337225',
    longitud: '-54.2725734279167',
  },
  232: {
    name: 'Riachuelo',
    latitud: '-34.4388243668816',
    longitud: '-57.7190887829836',
  },
  236: {
    name: 'El Colorado',
    latitud: '-34.7098878631005',
    longitud: '-56.2678543247231',
  },
  237: {
    name: 'Lomas de Carrasco',
    latitud: '-34.7835691388429',
    longitud: '-55.9684779407159',
  },
  239: {
    name: 'Quebracho',
    latitud: '-31.9340636403413',
    longitud: '-57.8982035658942',
  },
  240: {
    name: 'Aguas Dulces',
    latitud: '-34.2722187605616',
    longitud: '-53.785661527222',
  },
  241: {
    name: 'Barra de Valizas',
    latitud: '-34.3518741856312',
    longitud: '-53.8142584625824',
  },
  244: {
    name: 'Santa Teresa',
    latitud: '-33.9811908865032',
    longitud: '-53.532622355144',
  },
  245: {
    name: 'Punta del Diablo',
    latitud: '-34.0414081134302',
    longitud: '-53.5504415124385',
  },
  246: {
    name: 'Villa Ansina',
    latitud: '-31.8786649624934',
    longitud: '-55.4613869358791',
  },
  247: {
    name: 'Tambores',
    latitud: '-31.8771946277159',
    longitud: '-56.2443976927798',
  },
  249: {
    name: 'Boca del Cufre',
    latitud: '-34.4435468755333',
    longitud: '-57.1473074896991',
  },
  250: {
    name: 'Nuevo Berlin',
    latitud: '-32.977593396418',
    longitud: '-58.0330471658514',
  },
  252: {
    name: 'Zapican',
    latitud: '-33.5229955930094',
    longitud: '-54.9436149205982',
  },
  253: {
    name: 'Vichadero',
    latitud: '-31.7778990223218',
    longitud: '-54.6922791885202',
  },
  254: {
    name: 'Baltazar Brum',
    latitud: '-30.7128531451199',
    longitud: '-57.3249233482403',
  },
  255: {
    name: 'Pintado',
    latitud: '-33.8347023697173',
    longitud: '-56.3017658281421',
  },
  258: {
    name: 'Fraile Muerto',
    latitud: '-32.5195146752771',
    longitud: '-54.5249003696502',
  },
  259: {
    name: 'Santa Catalina',
    latitud: '-33.791246508319',
    longitud: '-57.4872754373411',
  },
  260: {
    name: 'Tomas Gomensoro',
    latitud: '-30.4242362592448',
    longitud: '-57.4360608607789',
  },
  262: {
    name: 'Los Talas',
    latitud: '-34.0927072112178',
    longitud: '-54.4907544813584',
  },
  263: {
    name: 'Constitucion',
    latitud: '-31.0738826441475',
    longitud: '-57.847745864122',
  },
  264: {
    name: 'La Pedrera',
    latitud: '-34.593459317148',
    longitud: '-54.1282662355057',
  },
  266: {
    name: 'Cerro Chato(Florida)',
    latitud: '-33.1100218848876',
    longitud: '-55.1394213376993',
  },
  267: {
    name: 'Lago Merin',
    latitud: '-32.7432309438273',
    longitud: '-53.2607578233404',
  },
  269: {
    name: 'Cerro Chato(Durazno)',
    latitud: '-33.0998780035046',
    longitud: '-55.1364130375386',
  },
  270: {
    name: 'Las Vegas',
    latitud: '-34.7418203713652',
    longitud: '-55.6987289969401',
  },
  271: {
    name: 'Guazuvira',
    latitud: '-34.7637809559564',
    longitud: '-55.6112689200555',
  },
  272: {
    name: 'Costa Azul (Rocha)',
    latitud: '-34.6293043907784',
    longitud: '-54.1630324335444',
  },
  273: {
    name: 'Bella Vista',
    latitud: '-34.8001954885012',
    longitud: '-55.3538037447077',
  },
  274: {
    name: 'Belen',
    latitud: '-30.7872942221598',
    longitud: '-57.7779721016271',
  },
  277: {
    name: 'Barra del Chuy',
    latitud: '-33.7505180436877',
    longitud: '-53.3969610835344',
  },
  278: {
    name: 'San Javier',
    latitud: '-32.6670948730821',
    longitud: '-58.1313766842403',
  },
  282: {
    name: 'Pueblo Nuevo',
    latitud: '-34.4409893052905',
    longitud: '-56.446606021337',
  },
  283: {
    name: 'Centenario',
    latitud: '-32.8287447572223',
    longitud: '-56.4936957521861',
  },
  285: {
    name: 'Chapicuy',
    latitud: '-31.6639753311308',
    longitud: '-57.8876971817854',
  },
  286: {
    name: 'Pueblo Palmar',
    latitud: '-33.0602578041548',
    longitud: '-57.4570673882257',
  },
  288: {
    name: 'Carlos Reyles',
    latitud: '-33.0634943350721',
    longitud: '-56.4694770723421',
  },
  289: {
    name: 'Piraraja',
    latitud: '-33.7394975013949',
    longitud: '-54.759895560602',
  },
  291: {
    name: 'La Aguada',
    latitud: '-34.6389440987574',
    longitud: '-54.1621878865192',
  },
  292: {
    name: 'Tapia',
    latitud: '-34.5648705976708',
    longitud: '-55.7484211645026',
  },
  293: {
    name: 'Pueblo Capurro',
    latitud: '-34.4361315381023',
    longitud: '-56.4650783561219',
  },
  294: {
    name: 'Arachania',
    latitud: '-34.6129335824156',
    longitud: '-54.1476576587218',
  },
  295: {
    name: 'Jose Ignacio',
    latitud: '-34.8273860597342',
    longitud: '-54.6254785683877',
  },
  296: {
    name: 'Curtina',
    latitud: '-32.1457200754617',
    longitud: '-56.1136853630742',
  },
  297: {
    name: 'Punta Rubia',
    latitud: '-34.571170086187',
    longitud: '-54.1130818125124',
  },
  298: {
    name: 'Balneario Ipora',
    latitud: '-31.6664060200759',
    longitud: '-55.9614693548981',
  },
  299: {
    name: 'Ismael Cortinas',
    latitud: '-33.9589882112226',
    longitud: '-57.0885554676943',
  },
  300: {
    name: 'Villa Olmos',
    latitud: '-34.7014676986144',
    longitud: '-55.9369988260487',
  },
  301: {
    name: 'Javier de Viana',
    latitud: '-30.4353194006456',
    longitud: '-56.7929318171866',
  },
  302: {
    name: 'Artilleros',
    latitud: '-34.4179477127826',
    longitud: '-57.5735389815095',
  },
  303: {
    name: 'Noblia',
    latitud: '-31.96094322485',
    longitud: '-54.12255034245',
  },
  305: {
    name: 'Ituzaingo',
    latitud: '-34.4212233960286',
    longitud: '-56.4282439313283',
  },
  307: {
    name: 'Nico Peréz',
    latitud: '-33.4837618977394',
    longitud: '-55.1632086306488',
  },
  322: {
    name: 'Toledo Chico',
    latitud: '-34.7531951873718',
    longitud: '-56.1066503547402',
  },
  324: {
    name: 'Achar',
    latitud: '-32.4038548665823',
    longitud: '-56.1833430879737',
  },
  328: {
    name: 'Acegua',
    latitud: '-31.8695763995951',
    longitud: '-54.1632816979304',
  },
  329: {
    name: 'Playa Fomento',
    latitud: '-34.4325726277581',
    longitud: '-57.2556443807842',
  },
  330: {
    name: 'La Campana',
    latitud: '-34.0329256125423',
    longitud: '-57.900185494143',
  },
  331: {
    name: 'San Luis',
    latitud: '-33.5993642977583',
    longitud: '-53.7177938697941',
  },
  332: {
    name: 'La Charqueada',
    latitud: '-33.203961427125',
    longitud: '-53.8079974053775',
  },
  334: {
    name: 'Caraguata',
    latitud: '-32.359963324411',
    longitud: '-55.0019660177226',
  },
  335: {
    name: 'Colonia Itapebí',
    latitud: '-31.3357951103723',
    longitud: '-57.4101039456213',
  },
  336: {
    name: 'Illescas',
    latitud: '-33.6085721628176',
    longitud: '-55.3285276384373',
  },
  338: {
    name: 'Punta Negra',
    latitud: '-34.8753119142588',
    longitud: '-55.1828411111452',
  },
  339: {
    name: 'Ocean Park',
    latitud: '-34.8722751311765',
    longitud: '-55.105487585178',
  },
  342: {
    name: 'Cassarino',
    latitud: '-34.7593810566396',
    longitud: '-56.068594460475',
  },
  343: {
    name: 'La cruz',
    latitud: '-33.9293071689446',
    longitud: '-56.2408070351731',
  },
  344: {
    name: 'Pueblo Gallinal',
    latitud: '-31.8841022568362',
    longitud: '-57.4780682386373',
  },
  345: {
    name: 'Rincón de Valentín',
    latitud: '-31.2842167347909',
    longitud: '-57.1984241080295',
  },
  346: {
    name: 'Balneario Argentino',
    latitud: '-34.7877605288364',
    longitud: '-55.4511072167149',
  },
  347: {
    name: 'Villa Serrana',
    latitud: '-34.3192348271207',
    longitud: '-54.9856991284846',
  },
  348: {
    name: 'La Esmeralda',
    latitud: '-34.158677174437',
    longitud: '-53.6906868628895',
  },
  349: {
    name: 'Villa Tambores',
    latitud: '-31.8784380957132',
    longitud: '-56.2432952350789',
  },
  350: {
    name: 'Baygorria',
    latitud: '-32.8814558987682',
    longitud: '-56.812795383934',
  },
  351: {
    name: 'Masoller',
    latitud: '-31.0843006181734',
    longitud: '-56.0021075660569',
  },
  352: {
    name: 'Buenos Aires',
    latitud: '-34.8912286735543',
    longitud: '-54.7985475128914',
  },
  353: {
    name: 'El Chorro',
    latitud: '-34.9010708567244',
    longitud: '-54.8130600207494',
  },
  354: {
    name: 'Villa Soriano',
    latitud: '-33.3995855564581',
    longitud: '-58.3220623213818',
  },
  355: {
    name: 'Rincón',
    latitud: '-32.8337869303471',
    longitud: '-53.8295686631091',
  },
  357: {
    name: 'Valentines',
    latitud: '-33.2580436945001',
    longitud: '-55.1023449701956',
  },
  358: {
    name: 'Reboledo',
    latitud: '-33.9927346950542',
    longitud: '-55.6503071374127',
  },
  359: {
    name: 'Paso Antolin',
    latitud: '-34.1992238531646',
    longitud: '-57.7867666196282',
  },
  360: {
    name: 'San Jorge',
    latitud: '-32.8413051833905',
    longitud: '-55.8956183595783',
  },
  361: {
    name: 'Monte Grande',
    latitud: '-34.7413494268238',
    longitud: '-56.4131828817572',
  },
  362: {
    name: 'Porvenir',
    latitud: '-32.391924783712',
    longitud: '-57.9703561532216',
  },
  363: {
    name: 'La Capuera',
    latitud: '-34.8581448668205',
    longitud: '-55.1050018173784',
  },
  366: {
    name: 'Placido Rosas',
    latitud: '-32.7549801296456',
    longitud: '-53.7157988430087',
  },
  367: {
    name: 'El Tesoro',
    latitud: '-34.9032835826791',
    longitud: '-54.8722574757086',
  },
  368: {
    name: 'Sauce de Portezuelo',
    latitud: '-34.8747800042898',
    longitud: '-55.1485674631721',
  },
  369: {
    name: 'Nueva Carrara',
    latitud: '-34.7187812007977',
    longitud: '-55.2550021492326',
  },
  370: {
    name: 'Estación Bizcocho',
    latitud: '-33.3638076158634',
    longitud: '-57.9629681654618',
  },
  371: {
    name: 'Cabo Polonio',
    latitud: '-34.3821866531184',
    longitud: '-53.8132211822079',
  },
  372: {
    name: 'Gral. Enrique Martínez',
    latitud: '-33.2043725853798',
    longitud: '-53.8066468458863',
  },
  374: {
    name: 'Constancia',
    latitud: '-32.2069643858223',
    longitud: '-58.005622815039',
  },
  375: {
    name: 'Villa 6 Hermanos',
    latitud: '-34.7139027329421',
    longitud: '-56.0661819696672',
  },
  376: {
    name: '19 de abril',
    latitud: '-34.3638589850905',
    longitud: '-54.06338662402',
  },
  377: {
    name: 'Bolivar',
    latitud: '-34.222785301319',
    longitud: '-55.728110393174',
  },
  378: {
    name: 'La Macana',
    latitud: '-34.0350127840551',
    longitud: '-56.1856998968905',
  },
  379: {
    name: 'Totoral del Sauce',
    latitud: '-34.6500500227021',
    longitud: '-55.9808414951451',
  },
  380: {
    name: 'Los Arrayanes',
    latitud: '-33.2268278208867',
    longitud: '-58.0348456782558',
  },
  381: {
    name: 'Pueblo Gerona',
    latitud: '-34.7675214699084',
    longitud: '-55.2470238825491',
  },
  384: {
    name: 'Chiuahua',
    latitud: '-34.8732986906699',
    longitud: '-55.091665392904',
  },
  386: {
    name: 'Balneario Blanca Arena',
    latitud: '-34.4312615775822',
    longitud: '-57.2983807655568',
  },
  387: {
    name: 'Parada Cabrera',
    latitud: '-34.6287040347881',
    longitud: '-56.2505893221948',
  },
  388: {
    name: 'Palo Solo',
    latitud: '-33.8301244213865',
    longitud: '-58.0223023244567',
  },
  389: {
    name: 'Las Toscas',
    latitud: '-32.1768907171417',
    longitud: '-55.0109261880339',
  },
  390: {
    name: 'Santa Monica',
    latitud: '-34.8471488567424',
    longitud: '-54.6960037667875',
  },
  391: {
    name: 'El Caracol',
    latitud: '-34.7731205017317',
    longitud: '-54.5417979671497',
  },
  392: {
    name: 'Cerros Azules',
    latitud: '-34.7696357636386',
    longitud: '-55.3666920205007',
  },
  393: {
    name: 'Pueblo Goñi',
    latitud: '-33.5191912165844',
    longitud: '-56.4158650568786',
  },
  395: {
    name: 'Puimayen',
    latitud: '-33.7703074296517',
    longitud: '-53.4065101885209',
  },
  396: {
    name: 'Cuchilla Peralta',
    latitud: '-32.4911490206113',
    longitud: '-56.3556568430662',
  },
  397: {
    name: 'Colinas de Carrasco',
    latitud: '-34.7873925255964',
    longitud: '-56.0153678268971',
  },
  398: {
    name: 'City Golf',
    latitud: '-34.7576432094137',
    longitud: '-55.7686426828135',
  },
  399: {
    name: 'Villa Arejo',
    latitud: '-34.5927368015494',
    longitud: '-56.1659717299317',
  },
  400: {
    name: 'Balneario Britópolis',
    latitud: '-34.4302518453734',
    longitud: '-57.2711789663703',
  },
  401: {
    name: 'Balneario Playa Azul',
    latitud: '-34.4324983853801',
    longitud: '-57.2632443795594',
  },
  402: {
    name: 'Frac. Cno. Andaluz y R.84',
    latitud: '-34.7661097963946',
    longitud: '-56.0766174887778',
  },
  403: {
    name: 'Palmares de la Coronilla',
    latitud: '-33.8514577616112',
    longitud: '-53.4923044869957',
  },
  404: {
    name: 'Mangrullo',
    latitud: '-32.0855757878276',
    longitud: '-54.04327467906',
  },
  406: {
    name: 'Piedras Coloradas',
    latitud: '-32.3734934067998',
    longitud: '-57.607209713603',
  },
  407: {
    name: 'Estación Atlántida',
    latitud: '-34.7451101231686',
    longitud: '-55.7543048218157',
  },
  409: {
    name: 'San Fernando Chico',
    latitud: '-34.7795421914968',
    longitud: '-56.3656045316585',
  },
  410: {
    name: 'Tomás Penino',
    latitud: '-34.7570930460287',
    longitud: '-56.4267486893558',
  },
  411: {
    name: 'San Gabriel',
    latitud: '-34.0379598079428',
    longitud: '-55.8872017566387',
  },
  412: {
    name: 'Santa Mónica',
    latitud: '-34.7375443909884',
    longitud: '-56.4301355909838',
  },
  413: {
    name: 'Safici',
    latitud: '-34.7477536915501',
    longitud: '-56.4162201685227',
  },
  414: {
    name: 'Villa Crespo y San Andrés',
    latitud: '-34.7370935598173',
    longitud: '-56.1099987778453',
  },
  415: {
    name: 'Arrozal Treinta y Tres',
    latitud: '-33.0425072032486',
    longitud: '-53.6962951913203',
  },
  416: {
    name: 'Cañada Nieto',
    latitud: '-33.6995573858271',
    longitud: '-58.1116330455623',
  },
  417: {
    name: 'Fraccionamiento Ruta 74',
    latitud: '-34.7130563005551',
    longitud: '-56.0591140938268',
  },
  419: {
    name: 'Paso Espinosa',
    latitud: '-34.4937463735673',
    longitud: '-56.2790849032331',
  },
  420: {
    name: 'Puntas de Maciel',
    latitud: '-33.6261199154498',
    longitud: '-56.3557892727638',
  },
  421: {
    name: 'Paso Bonilla',
    latitud: '-31.8069665805417',
    longitud: '-55.9776728689958',
  },
  422: {
    name: 'Cerro Carmelo',
    latitud: '-33.9829665539821',
    longitud: '-58.2310852726779',
  },
  423: {
    name: 'Colón',
    latitud: '-33.874858479172',
    longitud: '-54.725503282644',
  },
  424: {
    name: 'Santa Ana (Colonia)',
    latitud: '-34.4198464100147',
    longitud: '-57.5954308842954',
  },
  426: {
    name: 'El Ensueño',
    latitud: '-34.4174208649837',
    longitud: '-57.6088521768356',
  },
  427: {
    name: 'Puerto Inglés',
    latitud: '-34.205659555352',
    longitud: '-58.0702289968023',
  },
  428: {
    name: 'Arévalo',
    latitud: '-32.6392905124449',
    longitud: '-55.0780472686003',
  },
  429: {
    name: 'Balneario Los Pinos',
    latitud: '-34.4317345576352',
    longitud: '-57.2418014620264',
  },
  430: {
    name: 'Las Cañas',
    latitud: '-33.1625466444828',
    longitud: '-58.3549829531537',
  },
  431: {
    name: 'Andresito',
    latitud: '-33.1668333985447',
    longitud: '-57.1285537731859',
  },
  432: {
    name: 'Pueblo Lavalleja',
    latitud: '-31.095754485688',
    longitud: '-57.0259880267315',
  },
  433: {
    name: 'La Riviera',
    latitud: '-34.5458395145874',
    longitud: '-54.3243193098817',
  },
  434: {
    name: '18 de Julio',
    latitud: '-33.6849104724017',
    longitud: '-53.5387482002857',
  },
  435: {
    name: 'Rincón del Bonete',
    latitud: '-32.8321346529465',
    longitud: '-56.4269097209348',
  },
  436: {
    name: 'Villa María',
    latitud: '-34.5153959321778',
    longitud: '-56.7644329626761',
  },
  437: {
    name: 'Arenitas Blancas',
    latitud: '-31.420379267698',
    longitud: '-57.9851103126733',
  },
  438: {
    name: 'Radial Ruta 3',
    latitud: '-34.5505218965',
    longitud: '-56.7535666522207',
  },
  439: {
    name: 'Piedra Sola',
    latitud: '-32.0800399918809',
    longitud: '-56.3090473970024',
  },
  440: {
    name: 'Pueblo Beisso',
    latitud: '-32.3160151311332',
    longitud: '-57.0546356562169',
  },
  441: {
    name: 'Estación Solis',
    latitud: '-34.3699800210015',
    longitud: '-55.4491266144505',
  },
  442: {
    name: 'Eden Rock',
    latitud: '-34.8688329213834',
    longitud: '-54.7508817757786',
  },
  443: {
    name: 'Cuchilla de Ramírez',
    latitud: '-32.5406535612452',
    longitud: '-55.4797431407844',
  },
  445: {
    name: 'Independencia',
    latitud: '-34.3540869266829',
    longitud: '-56.3992822172713',
  },
  447: {
    name: 'San Antonio',
    latitud: '-34.5447712134462',
    longitud: '-54.0781648478377',
  },
  448: {
    name: 'Garzón',
    latitud: '-34.5950443741768',
    longitud: '-54.5384159504622',
  },
  449: {
    name: 'El Edén',
    latitud: '-34.6348175304523',
    longitud: '-55.0553487762474',
  },
  450: {
    name: 'Raigón',
    latitud: '-34.3399723186114',
    longitud: '-56.6752116300435',
  },
  451: {
    name: 'Juan Soler',
    latitud: '-34.3265211000938',
    longitud: '-56.7975330324126',
  },
  453: {
    name: 'Bañado Medina',
    latitud: '-32.4009558289155',
    longitud: '-54.3531195041195',
  },
  454: {
    name: 'Arbolito',
    latitud: '-32.6152649417516',
    longitud: '-54.2033505811998',
  },
  455: {
    name: 'Toledo (Cerro Largo)',
    latitud: '-32.5285876203402',
    longitud: '-54.5315352119131',
  },
  456: {
    name: 'Cerro de las cuentas',
    latitud: '-32.6243826193154',
    longitud: '-54.5924023715635',
  },
};



// WEBPACK FOOTER //
// ./src/common/address-form/Locations.js